import { render, staticRenderFns } from "./IndexPageCategoriesSection.vue?vue&type=template&id=203cc6c6&"
import script from "./IndexPageCategoriesSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageCategoriesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports